import {AbstractDataApiPlugin, PluginSettings} from './abstract-data-api-plugin';
import mitt, {Emitter} from 'mitt';

type ListEvent<T extends any, S extends PluginSettings> = {
  change: AbstractList<T, S>
};

/**
 * Base for a list plugin.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export abstract class AbstractList<T extends any, S extends PluginSettings> extends AbstractDataApiPlugin<S> {
  public emitter: Emitter<ListEvent<T, S>> = mitt<ListEvent<T, S>>();

  constructor(container: HTMLElement) {
    super(container);
  }
}
